import React, { useEffect, useState } from 'react';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import Select from 'react-select';
import clsx from 'clsx';
import styles from './PlantDropdownSelector.module.css';

const PlantDropdownSelector = ({
  isDarkStyle,
  sequenceAdherenceDashBoard,
  setPlantValueForSequenceAdherence,
}) => {
  const [plant, setPlant] = usePlantAndLinesStore().plantState;
  const [plantOptions] = usePlantAndLinesStore().plantOptions;
  const [plantValueForSeqAdherence, setPlantValueForSeqAdherence] = useState({
    value: '9000',
    label: 'ALL',
  });
  const handlePlantChange = valueObject => {
    setPlant(valueObject);
  };

  const handlePlantChangeForSeqAdherence = value => {
    setPlantValueForSeqAdherence(value);
    setPlantValueForSequenceAdherence(value);
  };


  const customStyles = {
    control: provided => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
      background: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  const AddAlltoPlantOptions = plantOptions => {
    const plantOptionsForSeqAdherence = plantOptions.map(record => record);
    plantOptionsForSeqAdherence.unshift({ value: '9000', label: 'ALL' });
    return plantOptionsForSeqAdherence;
  };

  useEffect(() => {
    setPlantValueForSequenceAdherence({ value: '9000', label: 'ALL' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return sequenceAdherenceDashBoard === 'Seq. Adherence' ? (
    <Select
      value={plantValueForSeqAdherence}
      styles={customStyles}
      classNamePrefix="select-line"
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      onChange={handlePlantChangeForSeqAdherence}
      options={AddAlltoPlantOptions(plantOptions)}
    />
  ) : (
    <Select
      value={plant}
      styles={customStyles}
      classNamePrefix="select-line"
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      onChange={handlePlantChange}
      options={plantOptions}
    />
  );
};

export default PlantDropdownSelector;
